import React, { useCallback, useEffect, useState } from "react";
import './profile-setup.css'
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { IconContext } from 'react-icons';
import csLogo from '../../assets/images/cybersquare_logo.png'
import whatsappIcon from '../../assets/images/whatsapp.png'
import { useLocation, useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-input-2'
import { get_profile_details, activateUserAccount } from "../../services/login-api.js";
import ProfileSetupModal from "../modal/profileSetup-modal.js";
import { Checkbox, Progress } from "antd";
import CutomStatus from "./profile-setup-status.js";
import { useForm } from "react-hook-form";

const ProfileSetup = () => {

    const [mobileNumber, setMobileNumber] = useState({ dialCode: '+91', number: '' });
    const [WhatsappContact, setWhatsappContact] = useState({})
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [IsStatusVisible, setIsStatusVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [signupStatus, setStatus] = useState(200)
    const [maxDate, setMaxDate] = useState('');
    const [agreepolicy, setAgreePolicy] = useState(false)
    const [sameAsContact, setSameAsContact] = useState(false)
    const [currentStep, setCurrentStep] = useState(0);

    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userLoginId = queryParams.get('userloginid');

    const form = useForm({});
    const { register, handleSubmit, reset, formState, watch, trigger } = form
    const { errors } = formState;

    const pswd = watch('password', '');
    const confirmPwd = watch('confirmPswd', '');
    const selectedGender = watch('gender', '');
    const selectedDob = watch('dob', '')

    const getUserProfile = useCallback(async (userLoginId) => {
        try {
            const response = await get_profile_details({ 'userLoginId': userLoginId });
            // Handle the response here
            if (response.data.statusCode === 200) {
                if (response.data.profile) {
                    reset({
                        username: response.data.profile[0].userName,
                        teachername: response.data.profile[0].firstName
                    })
                } else {
                    setModalMessage("Your account details could not be found. Please contact the administrator for assistance.");
                    setIsModalVisible(true);
                }
            } else {
                setModalMessage("Your account has already been updated. Please try to log in.");
                setIsModalVisible(true);
            }
        } catch (error) {
            if (error.response) {
                setModalMessage("Your account has already been updated. Please try to log in.");
                setIsModalVisible(true);
            }
        }
    }, [reset])

    useEffect(() => {

        if (userLoginId) {
            getUserProfile(userLoginId)

            // for getting current date
            // alredy used in Date Of Birth Input. For Preventing Future Date
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            setMaxDate(formattedDate);

        } else {
            navigate('/login')
        }

    }, [userLoginId, getUserProfile, navigate]);

    const nextStep = async () => {
        const valid = await trigger(currentStep === 0 ? ['username', 'teachername', 'password', 'confirmPswd'] : '')
        if(valid){
            setCurrentStep(currentStep + 1)
        }
    }

    // const previousStep = () => {
    //     setCurrentStep(0)
    // }

    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword((prevShowPassword) => !prevShowPassword)
    }

    const handleModalClose = () => {
        setIsModalVisible(false);
        navigate('/login');
    };

    const handleCutomStatusResponse = (e) => {
        setIsStatusVisible(e.IsStatusVisible)
        setAgreePolicy(false)
        if (!e.IsStatusVisible) {
            setCurrentStep(0)
        }
    }


    const onSubmit = async (data) => {
        try {
            if(agreepolicy){

                let updateObj = {
                    'userloginid': userLoginId,
                    'userName': data['username']
                };
    
                if (data['teachername'] === '') {
                    setCurrentStep(0)
                    return
                }else{
                    updateObj['firstName'] = data['teachername']
                }
    
                if (data['password'] && data['confirmPswd']){
                    if(data['password'] === data['confirmPswd']) {
                        updateObj['password'] = data['password']
                    }else{
                        setCurrentStep(0)
                        return
                    }
                }else{
                    setCurrentStep(0)
                    return
                }
    
                if (mobileNumber['number'] && mobileNumber['dialCode']) {
                    const formattedMobileDialCode = {
                        ...mobileNumber, dialCode: `+${mobileNumber.dialCode}`,
                    };
                    updateObj['mobileNumber'] = formattedMobileDialCode
                }
    
                if (WhatsappContact['number'] && WhatsappContact['dialCode']) {
                    const formattedWhatsAppDialCode = {
                        ...WhatsappContact, dialCode: `+${WhatsappContact.dialCode}`,
                    };
                    updateObj['whatsappContact'] = formattedWhatsAppDialCode
                }
    
                if(data['gender'] !== ''){
                    updateObj['gender'] = data['gender']
                }
    
                if(data['dob'] !== ''){
                    updateObj['dob'] = data['dob']
                }
    
                // Make the asynchronous call
                const response = await activateUserAccount(updateObj);
                // Handle the response here
                if (response.data.statusCode === 200) {
                    setModalMessage("Your account is updated. Please try to log in.");
                    setIsStatusVisible(true);
                    setStatus(200)
                } else {
                    setStatus(401)
                    setIsStatusVisible(true)
                }
            }else{
                setCurrentStep(1)
            }


        } catch (error) {
            setStatus(500)
            setModalMessage("An error occurred. Please contact the administrator for assistance.");
            setIsStatusVisible(true);
        }
    };

    const handleMobileInput = (value, data) => {
        const obj = {
            dialCode: data['dialCode']
        }
        const number = value.startsWith(data['dialCode']) ? value.slice(data['dialCode'].length) : value;
        obj['number'] = number
        setMobileNumber(obj)
        setSameAsContact(false)
    }

    const handleWhatsAppInput = (value, data) => {
        const obj = {
            dialCode: data['dialCode']
        }
        const number = value.startsWith(data['dialCode']) ? value.slice(data['dialCode'].length) : value;
        obj['number'] = number
        setWhatsappContact(obj)
        setSameAsContact(false)
    }

    const handleCheckboxClick = (e) => {
        const checked = e.target.checked;
        if (checked) {
            setSameAsContact(true)
            setWhatsappContact({ ...mobileNumber });
        } else {
            setSameAsContact(false)
            setWhatsappContact({ dialCode: '', number: '', countryCode: "", format: "", name: "" })
        }
    };

    const agreePolicy = (e) => {
        const checked = e.target.checked;
        if (checked) {
            setAgreePolicy(true)
        } else {
            setAgreePolicy(false)
        }
    }


    return (
        <div className='container-fluid'>
            <div className='row main-background-profileSetup'>
                <div className='col-12 d-flex justify-content-center align-items-center' style={{ padding: '20px 0px' }}>
                    {!IsStatusVisible ? (

                        <div className='col-md-6 col-12 p-4 rounded-4 form'>
                            <div className="col-12 mt-0" style={{ display: 'flex', justifyContent: 'center' }}>
                                <img src={csLogo} alt="cs logo" style={{ width: '180px' }} />
                            </div>
                            <div className=" mt-2" style={{ display: 'flex', justifyContent: 'center' }}>
                                <h3 style={{ fontWeight: "bolder", fontFamily: 'Poppins', fontSize: '20px' }}>Welcome to Cyber Square</h3>
                            </div>
                            <div className=" mt-1" style={{ display: 'flex', justifyContent: 'center' }}>
                                <h3 style={{ fontFamily: 'Poppins', fontSize: '15px' }}>Complete your account setup here</h3>
                            </div>
                            <div className="col-12 mt-2 mb-4" style={{ display: 'flex', justifyContent: 'center' }}>
                                <div className="col-6">
                            <div className="progress-container">
                                <div className={`progress-step-number ${currentStep >= 0 ? 'active' : ''}`}>1</div>
                                <Progress percent={currentStep === 0 ? 50 : 100} showInfo={false} strokeWidth={2} strokeColor="#11BA0E" />
                                <div className={`progress-step-number ${currentStep === 1 ? 'active' : ''}`}>2</div>
                            </div>
                                   
                                </div>
                            </div>

                            {/* registration Form */}

                            <form data-testid='profileForm' className="row" onSubmit={handleSubmit(onSubmit)}>

                                {currentStep === 0 ? (
                                    <>
                                        <div className="col-1"></div>
                                        <div className="form-group mb-md-3 mb-4 col-10" >
                                            <label htmlFor="username" className='pb-3 pb-md-2 custom-label' >Username</label>
                                            <input
                                                type="text"
                                                id="username"
                                                className='new-form-control rounded-1 border-0 input-height'
                                                placeholder="Username/Email"
                                                disabled
                                                name="username"
                                                {...register('username', {
                                                    required: {
                                                        value: true,
                                                        message: 'username is required to procceed'
                                                    }
                                                })}
                                            />
                                        </div>
                                        <div className="col-1"></div>

                                        <div className="col-1"></div>
                                        <div className="form-group mb-md-3 mb-4 col-10">
                                            <label htmlFor="teachername" className='pb-3 pb-md-2 custom-label' >Name</label>
                                            <input
                                                type="text"
                                                id="teachername"
                                                className='new-form-control rounded-1 border-0 input-height'
                                                placeholder="Teacher Name"
                                                name="teachername"
                                                {...register('teachername', {
                                                    required: {
                                                        value: true,
                                                        message: 'Enter your name to proceed'
                                                    }
                                                })}
                                            />
                                            <div className="error-message">{errors.teachername?.message}</div>
                                        </div>
                                        <div className="col-1"></div>

                                        <div className="col-1"></div>
                                        <div className="form-group mb-md-3 mb-4 col-10">
                                            <label htmlFor="pswd" className='pb-3 pb-md-2 custom-label' >Password</label>
                                            <div className='input-group'>
                                                <input
                                                    type={showPassword ? 'text' : 'password'}
                                                    id='pswd'
                                                    className='new-form-control rounded-1 border-0 input-height'
                                                    placeholder="Enter password"
                                                    name="password"
                                                    {...register('password', {
                                                        required: {
                                                            value: true,
                                                            message: 'Enter your password to proceed.'
                                                        },
                                                        minLength: {
                                                            value: 8,
                                                            message: 'Password must be at least 8 characters'
                                                        },
                                                        pattern: {
                                                            value: /^(?=.*[0-9])(?=.*[!@#$%^&*])/,
                                                            message: 'Password must include at least one number and one special character.'
                                                        }
                                                    })}
                                                />

                                                {pswd.length > 0 && (
                                                    <div className='input-group-append'>
                                                        <IconContext.Provider value={{ size: '1.5em' }}>
                                                            <span className='input-group-text' onClick={togglePasswordVisibility} style={{ border: 'none', cursor: 'pointer', backgroundColor: 'transparent', marginLeft: '-37px', position: 'absolute', marginTop: '11px' }}>
                                                                {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                                            </span>
                                                        </IconContext.Provider>
                                                    </div>
                                                )}
                                                <div className="error-message">{errors.password?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-1"></div>

                                        <div className="col-1"></div>
                                        <div className="form-group md-mb-4 mb-4 col-10">
                                            <label htmlFor="confirmPswd" className='pb-3 pb-md-2 custom-label' >Confirm Password</label>
                                            <div className='input-group'>
                                                <input
                                                    type={showConfirmPassword ? 'text' : 'password'}
                                                    id='confirmPswd'
                                                    className={`new-form-control rounded-1 border-0 input-height`}
                                                    placeholder='Enter password'
                                                    name="confirmPswd"
                                                    {...register('confirmPswd', {
                                                        required: {
                                                            value: true,
                                                            message: 'Enter your Confirm Password to procceed.'
                                                        },
                                                        validate : value => value === pswd || 'Confirm Password must be Same as password'
                                                    })}
                                                />

                                                {confirmPwd.length > 0 && (
                                                    <div className='input-group-append'>
                                                        <IconContext.Provider value={{ size: '1.5em' }}>
                                                            <span className='input-group-text' onClick={toggleConfirmPasswordVisibility} style={{ border: 'none', cursor: 'pointer', backgroundColor: 'transparent', marginLeft: '-37px', position: 'absolute', marginTop: '11px' }}>
                                                                {showConfirmPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                                            </span>
                                                        </IconContext.Provider>
                                                    </div>
                                                )}
                                                <div className="error-message">{errors.confirmPswd?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-1"></div>

                                        <div className="text-center mb-3 mb-md-2 mt-5 mt-md-4 col-12">
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div className="col-6">
                                                    <button type="submit" className="btn btn-warning form-control" style={{
                                                        backgroundColor: "#FF0000",
                                                        color: "white",
                                                        borderRadius: "10px",
                                                        display: "block",
                                                        boxShadow: errors
                                                            ? "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1)"
                                                            : "0 4px 6px rgba(255, 110, 98, 0.5), 0 1px 3px rgba(255, 110, 98, 0.5)",
                                                        height: '50px'
                                                    }} data-testid='signInButton' onClick={nextStep}>Next</button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className="col-12 mt-md-2">
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div className="lined-text-container col-10">
                                                    <span className="lined-text">Or</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div className="col-7">
                                                    <button type="button" className='google-btn mt-4' onClick={handleGoogleSign}>
                                                        <img src={googleIcon} alt="google icon" className='icon img-google' />
                                                        <span className='responsive-google-text' style={{ fontFamily: 'Poppins', fontWeight: 'bold' }}>Sign in with Google</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div> */}
                                    </>
                                ) : (
                                    // step Two
                                    <>
                                        <div className="col-1"></div>
                                        <div className="form-group mb-md-3 mb-4 col-9">
                                            <label htmlFor="mobile" className='pb-3 pb-md-2 custom-label' >Mobile Number</label>
                                            <PhoneInput
                                                placeholder={'Enter Number'}
                                                value={
                                                        `+${mobileNumber.dialCode}${mobileNumber.number}`
                                                }
                                                containerClass={"form-group mb-md-3 mb-4 rounded-1 border-0 input-height "}
                                                inputStyle={{ width: '100%', height: '40px', boxShadow: '0 0 0 .05rem #f5692d', paddingLeft: '70px', border: 'none' }}
                                                inputProps={{
                                                    name: 'mobile',
                                                    autoFocus: false,
                                                }}
                                                onChange={(value, data) => handleMobileInput(value, data)}
                                            />
                                            <div>
                                                <Checkbox checked={sameAsContact} onChange={handleCheckboxClick} className="custom-label" >Using same Whatsapp number</Checkbox><span className="useText"></span>
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            {/* <label className="pt-3 " style={{ marginTop: '27px', color: '#f5692d' }}>Verify</label> */}
                                        </div>
                                        <div className="col-1"></div>
                                        <div className="form-group mb-md-3 mb-4 col-9">
                                            <label htmlFor="whatsappmobile" className='pb-3 pb-md-2 custom-label' >WhatsApp Number <img src={whatsappIcon} style={{width:'20px'}} alt="Whatsapp icon"></img></label>
                                            <PhoneInput
                                                placeholder={'Enter Number'}
                                                value={
                                                    WhatsappContact.number
                                                        ? `+${WhatsappContact.dialCode}${WhatsappContact.number}`
                                                        : ''
                                                }
                                                containerClass={"form-group mb-md-3 mb-4 rounded-1 border-0 input-height "}
                                                inputStyle={{ width: '100%', height: '40px', boxShadow: '0 0 0 .05rem #f5692d', paddingLeft: '70px', border: 'none' }}
                                                inputProps={{
                                                    name: 'whatsappmobile',
                                                }}
                                                onChange={(value, data) => handleWhatsAppInput(value, data)}
                                            />
                                        </div>
                                        <div className="col-2"></div>
                                        <div className="col-1"></div>
                                        <div className="form-group mb-md-3 mb-4 col-4" >
                                            <label htmlFor="gender" className='pb-3 pb-md-2 custom-label' >Gender</label>
                                            <select
                                            name="gender"
                                            id="gender"
                                            className={`new-form-control rounded-1 border-0 input-height`}
                                            style={{color : selectedGender === '' ? 'rgb(93 90 90)': 'black', fontSize: '14px'}}
                                            {...register('gender')}
                                            >
                                                <option disabled selected value='' >Select Gender</option>
                                                <option value='male'>Male</option>
                                                <option value='female'>Female</option>
                                                <option value='Other'>Other</option>
                                                <option value='Prefer not to say'>Prefer not to say</option>
                                            </select>
                                        </div>

                                        <div className="form-group mb-md-3 mb-4 col-5" >
                                            <label htmlFor="dob" className='pb-3 pb-md-2 custom-label' >Date of Birth</label>
                                            <input
                                                type="date"
                                                id="dob"
                                                name="dob"
                                                className='new-form-control rounded-1 border-0 input-height'
                                                placeholder="dob"
                                                max={maxDate}
                                                {...register('dob')}
                                                style={{color: selectedDob === '' ? 'rgb(93 90 90)': 'black' ,fontSize: '14px' }}
                                            />
                                        </div>

                                        <div className="col-2"></div>
                                        <div className="col-1"></div>
                                        <div className="col-8 ">
                                            <Checkbox onChange={agreePolicy} checked={agreepolicy} className="custom-label" >I agree to receive important information and updates through WhatsApp</Checkbox><span className="useText"></span>
                                        </div>

                                        <div className="text-center mb-3 mb-md-5 mt-5 mt-md-4 col-12">
                                            <div style={{ display: 'flex', justifyContent: 'center' }} className="mb-md-5">
                                                <div className="col-6">
                                                    <button type="submit" className="btn btn-warning form-control" style={{
                                                        backgroundColor: "#FF0000",
                                                        color: "white",
                                                        borderRadius: "10px",
                                                        display: "block",
                                                        boxShadow: agreepolicy
                                                            ? "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1)"
                                                            : "0 4px 6px rgba(255, 110, 98, 0.5), 0 1px 3px rgba(255, 110, 98, 0.5)",
                                                        height: '50px'
                                                    }} data-testid='signInButton' disabled={!agreepolicy}>Sign Up</button>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}


                            </form>
                        </div>
                    ) : (
                        <CutomStatus
                            status={signupStatus}
                            response={handleCutomStatusResponse}
                        />
                    )
                    }
                </div>
            </div>
            {/* Modal section */}
            <ProfileSetupModal
                visible={isModalVisible}
                onClose={handleModalClose}
                message={modalMessage} // Pass the message to the modal
            />
        </div>

    );

};

export default ProfileSetup;